/**
 * Credencial do handshake do Socket.IO. O backend recusa conexão sem token
 * válido em TODOS os namespaces (middleware no SocketIoAdapter — S-02 de
 * docs/security/aplicacao/REVISAO_SEGURANCA_MERGE_2026-09-30.md). Função, e não objeto:
 * o Socket.IO a chama a cada (re)conexão, então um token renovado vale na
 * reconexão seguinte.
 */
export function socketAuth(cb: (data: Record<string, unknown>) => void): void {
  let token = ''
  try {
    token = localStorage.getItem('token') ?? ''
  } catch {
    token = ''
  }
  cb({ token })
}
